import { motion } from 'motion/react';
import type { WorkOption } from '../types';

interface WorkShapesProps {
  step?: 1 | 2 | 3;
  selectedWorkOption: WorkOption | null;
}

export function WorkShapes({ step = 1, selectedWorkOption }: WorkShapesProps): JSX.Element {
  const getContainerStyle = () => {
    if (step === 3) {
      return { transform: 'translate(-190px, 200px) scale(1)', opacity: 1 };
    }
    if (step === 2 && selectedWorkOption !== null) {
      return { transform: 'translate(-280px, -150px) scale(0.9)', opacity: 0.4 };
    }
    return undefined;
  };

  return (
    <div
      className="absolute left-[480px] top-[220px] transition-all duration-1000"
      style={getContainerStyle()}
    >
      <motion.div
        className="flex items-center justify-center"
        initial={{ opacity: 0, rotate: 180 }}
        animate={{ opacity: 1, rotate: 0 }}
        exit={{ opacity: 0, rotate: -180 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <div className="flex-none scale-y-[-100%] size-[330.98px] overflow-clip">
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 331 331"
          >
            <g id="Group">
              <path
                clipRule="evenodd"
                d="M82.7451 0H0V165.49C0 256.887 74.0925 330.98 165.49 330.98C256.887 330.98 330.98 256.887 330.98 165.49V0H248.235C202.537 0 165.49 37.0463 165.49 82.7451C165.49 37.0463 128.444 0 82.7451 0Z"
                fill="#816EFF"
                fillRule="evenodd"
                id="Vector"
              />
            </g>
          </svg>
        </div>
      </motion.div>
      <motion.div
        className="absolute size-[305.397px] -left-[140px] top-[160px]"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 306 306"
        >
          <circle cx="152.699" cy="152.699" fill="#FFD042" id="Ellipse 13" r="152.699" />
        </svg>
      </motion.div>
    </div>
  );
}
